module.exports = __webpack_public_path__ + "media/assets/images/default_avatar-56412de1e54f0a29005fc13355499cab.png";